var lastScrollTop = 0;
stickyHeader();
jQuery(document).scroll(function(){
  stickyHeader();
});


jQuery('.burger').click(function(){
  jQuery(this).toggleClass('burger--active');
  jQuery('.mobile-menu').toggleClass('mobile-menu--active');
  jQuery('html, body').toggleClass('overflow');
  return false;
});

jQuery('.mobile-menu .nav__link').click(function(){
  jQuery('.burger').removeClass('burger--active');
  jQuery('.mobile-menu').removeClass('mobile-menu--active');
  jQuery('html, body').removeClass('overflow');
});


jQuery('.js-scroll-to').click(function(e){
  e.preventDefault();
  var anchor = jQuery(this).attr('href');
  var scrollPos = jQuery(anchor).offset().top;
  jQuery('html, body').animate({ scrollTop: scrollPos }, 600)
});

function stickyHeader() {
  var el = jQuery('.header');
  if (jQuery(window).scrollTop() >= 100) {
    el.addClass('header--sticky');
  } else {
    if (el.hasClass('header--sticky')) {
      el.removeClass('header--sticky');
    }
  }
}

jQuery('.tab-btn').click(function(e){
  e.preventDefault();
  var i = jQuery(this);
  var href = i.attr('href');
  jQuery('.tab-btn').removeClass('btn--green').addClass('btn--green-outline');
  i.removeClass('btn--green-outline').addClass('btn--green');

  jQuery('.tab-item').addClass('hidden');
  jQuery('#'+href.replace('/#', '')).removeClass('hidden');
})


jQuery('.product-tabs__btn').click(function(e){
  e.preventDefault();
  var i = jQuery(this);
  var href = i.attr('href');
  jQuery('.product-tabs__btn').removeClass('product-tabs__btn-active');
  i.addClass('product-tabs__btn-active');

  jQuery('.product-tabs__tab').addClass('hidden');
  jQuery('#'+href.replace('/#', '')).removeClass('hidden');
})

